import { createBasicSelector } from 'util/redux'
import { selectProduct } from './selectProduct'

export const selectIsFreemium = createBasicSelector(
  selectProduct,
  plan =>
    [
      'v9-standard',
      'v9-standard-annual',
      'v18-free',
      'v18-free-annual',
    ].indexOf(plan.plan) !== -1
)
